import { ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import { EncryptDecryptService } from "../services/encrypt-decrypt.service";
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';

declare interface DataTable {
  headerRow: string[];
  footerRow: string[];
  dataRows: string[][];
}

@Component({
  selector: 'app-piece-jointe',
  templateUrl: './piece-jointe.component.html',
  styleUrls: ['./piece-jointe.component.css']
})
export class PieceJointeComponent implements OnInit {
  dtOptions: DataTables.Settings = {};
  public dataTable: DataTable;
  private base64textString = "";
  apikey: string;
  user: any;
  jsonData: string;
  urlviewer: string;
  urlviewerCL: string;
  table: any;
  show = false;
  show2 = false;
  showconsent = false;
  consent: Consentement;
  _consentement: string;

  pjType = '';

  url: string;

  dtTrigger: Subject<any> = new Subject();

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;

  public selected = '';

  constructor(public changeDetectorRefs: ChangeDetectorRef, private encdec: EncryptDecryptService, private http: HttpClient, private _snackBar: MatSnackBar) {
    this.getCandidate();
  }

  getCandidate() {
    this.http.get('https://api2.sitederecrutement.com/Home/getcandidate?apikey=' + localStorage.getItem('apikey') + '&login=' + JSON.parse(localStorage.getItem('currentUser')).candidat_api, { responseType: "text" }).subscribe(
      (result) => {
        this.jsonData = this.encdec.getDecrypt( result);
        let jsonObject: any = JSON.parse(this.jsonData);
        this.dataTable.dataRows.splice(0, this.dataTable.dataRows.length - 1);
        this.dataTable.dataRows.push(['CV', 'Candidature Spontanée', jsonObject.profil.profil_pj1, 'profil_pj1']);
/*        this.dataTable.dataRows.push(['Lettre de Motivation', 'Candidature Spontanée', jsonObject.profil.profil_pj2, 'profil_pj2']);*/
        this.dataTable.dataRows.push(['Consentement RGPD', 'Candidature Spontanée', 'Consentement', 'consentement']);
        this.consent = jsonObject.consentement_info;
        this.http.get('https://api2.sitederecrutement.com/Home/GetConsentement?apikey=' + localStorage.getItem('apikey'), { responseType: 'text' }).subscribe(
          result => {
            const jsonData = this.encdec.getDecrypt(result);
            let jsonObject: any = JSON.parse(jsonData);
            this._consentement = jsonObject.result;
          }
        );
        this.rerender();
      }
    );
  }

  ngOnInit(): void {
    this.dataTable = {
      headerRow: ['Nom', 'Poste', 'Actions'],
      footerRow: ['Nom', 'Poste', 'Actions'],

      dataRows: [
      ]
    };
    this.dtOptions = {
      paging: false,
      searching: false,
      responsive: true,
      info: false,
    };
  }

  ngAfterViewInit() {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  openFile(event: MouseEvent) {
    ((event.srcElement as HTMLElement).children.namedItem('filediag') as HTMLElement)?.click();
  }

  handle(event, type) {
    this.pjType = type;
    var files = event.target.files;
    var file = files[0];

    if (files && file) {
      var reader = new FileReader();

      reader.onload = this._handleReaderLoaded.bind(this);
      reader.readAsArrayBuffer(file);
    }
  }

  _arrayBufferToBase64( buffer ) {
    var binary = '';
    var bytes = new Uint8Array( buffer );
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode( bytes[ i ] );
    }
    return btoa(binary);
  }

  _handleReaderLoaded(readerEvt) {
    
    var buffer = readerEvt.target.result;
    //var uint8 = new Uint8Array(binaryString);
    //var result = Array.from(uint8);

    var bs4String = this._arrayBufferToBase64( buffer );
    let objProfil: profil;
    if (this.pjType === "profil_pj1") {
      objProfil = {
        profil_pj1: bs4String,
        profil_pj2: "",
        profil_pj1_nom: "Curriculum Vitae",
        profil_pj2_nom: ""
      };
    } else if (this.pjType === "profil_pj2") {
      objProfil = {
        profil_pj2: bs4String,
        profil_pj1: "",
        profil_pj2_nom: "Lettre de Motivation",
        profil_pj1_nom: ""
      };
    }

    let obj: PieceJointe = {
      idcandidat: JSON.parse(localStorage.getItem('currentUser')).idcandidat,
      profil: objProfil
    };


    let data = this.encdec.getEncrypt( JSON.stringify(obj));
    const formData = new FormData();
    formData.append('datas', data);

    this.http.post('https://api2.sitederecrutement.com/Home/updatecandidate?apikey=' + localStorage.getItem('apikey'), formData, { responseType: "text" }).subscribe(
      (result) => {
        this._snackBar.open("Votre pièce jointe a bien été enregistrée", 'Fermer', {
          duration: 5 * 1000,
        })
        this.jsonData = this.encdec.getDecrypt( result);
        let jsonObject: any = JSON.parse(this.jsonData);

        this.dataTable.dataRows = [
        ];
        this.dataTable.dataRows.push(['Curriculum Vitae', 'Dossier personnel', jsonObject.profil.profil_pj1, 'profil_pj1']);
/*        this.dataTable.dataRows.push(['Lettre de Motivation', 'Dossier personnel', jsonObject.profil.profil_pj2, 'profil_pj2']);*/
        if (this.pjType === "profil_pj1")
          this.url = jsonObject.profil.profil_pj1;
        else if (this.pjType === "profil_pj2")
          this.url = jsonObject.profil.profil_pj2;
      }
    );
  }

  onClick(event) {
    this.selected = event.currentTarget.id;
  }

  onClear(){
    this.selected = '';
  }

}

interface profil{
  profil_pj1: any;
  profil_pj2: any;
  profil_pj1_nom: any;
  profil_pj2_nom: any;
}

interface PieceJointe {
  idcandidat: string;
  profil: profil;
}

interface Consentement {
  idconsentement: number;
  consentement_date: string;
  consentement_heure: string;
}
